import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from './store/store';
// import en from './assets/locales/en.json'

Vue.use(VueI18n);

function loadLocaleMessages () {
  const locales = require.context('./assets/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
    locale: store.getters.currentLng,
    messages: loadLocaleMessages()
});

export default i18n;
